/**
 * GoldSweep — premium reveal effect: a horizontal gold scan-line sweeps
 * across its container with a soft amber haze pulsing in tandem. Three
 * stacked layers (haze, sharp line, blurred trailing band) so it reads as
 * a depth-aware light pass rather than a flat sliding bar.
 *
 * Render inside any `position: relative` container; it absolutely positions
 * itself to fill that parent.
 */

const GOLD = "#f5a623";

export function GoldSweep() {
  return (
    <>
      {/* Soft amber haze — radial pulse from centre. mix-blend-mode: screen
          adds light over the dark UI without flattening the colours below. */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          background: `radial-gradient(50% 35% at 50% 50%, ${GOLD}30 0%, ${GOLD}10 40%, transparent 70%)`,
          animation: "hh-gold-flash 720ms cubic-bezier(0.4, 0, 0.2, 1) forwards",
          pointerEvents: "none",
          zIndex: 4,
          mixBlendMode: "screen",
        }}
      />
      {/* Bright 1.5px gold scan-line + glow rings */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: "50%",
          height: 1.5,
          marginTop: -0.75,
          background: `linear-gradient(90deg, transparent 0%, ${GOLD}66 18%, ${GOLD} 50%, ${GOLD}66 82%, transparent 100%)`,
          boxShadow: `
            0 0 8px ${GOLD}cc,
            0 0 24px ${GOLD}88,
            0 0 56px ${GOLD}66
          `,
          animation:
            "hh-gold-sweep 720ms cubic-bezier(0.45, 0.05, 0.55, 0.95) forwards",
          pointerEvents: "none",
          zIndex: 6,
        }}
      />
      {/* Trailing blurred band for depth — slight lag for parallax */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: "50%",
          height: 22,
          marginTop: -11,
          background: `linear-gradient(90deg, transparent 0%, ${GOLD}10 40%, ${GOLD}22 50%, ${GOLD}10 60%, transparent 100%)`,
          filter: "blur(6px)",
          animation:
            "hh-gold-sweep 720ms cubic-bezier(0.45, 0.05, 0.55, 0.95) 30ms forwards",
          pointerEvents: "none",
          zIndex: 5,
        }}
      />
    </>
  );
}
